import apiClient from './index'

export default {
  login(username, password) {
    // Usar application/x-www-form-urlencoded para OAuth2PasswordRequestForm
    const form = new URLSearchParams()
    form.append('username', username)
    form.append('password', password)

    // Log para depuración
    console.log(`Intentando login con usuario: ${username}`)

    // Evitar 307 por barras finales: llamar a la ruta canónica con /
    return apiClient.post('/auth/token/', form, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },

  register(username, email, password) {
    return apiClient.post('/auth/register', {
      username,
      email,
      password
    })
  },

  getProfile() {
    return apiClient.get('/auth/me')
  }
}